"use client";
import styles from './styles.module.scss';
import { useState, useEffect } from 'react';
import Selector from './Selector';
import CapabilityCard from './CapabilityCard';

const ProductCapabilities = props => {
    const [selectedCategory, setSelectedCategory] = useState(``);
    const {headline, copy, productCategories} = props || {};

    useEffect(()=>{
        setSelectedCategory(productCategories[0].productCategoryTitle)
    },[])
    const renderHeadline = () => {
        if(!headline) return false;

        return(
            <h2 className={styles.capabilities__headline}>
                {headline}
            </h2>
        );
    }

    const renderCopy = () => {
        return(
            <div className={styles.capabilities__copy} dangerouslySetInnerHTML={{__html: copy || ``}}/>

        );
    }

    const renderCategories = () => {
        return productCategories && productCategories.map((category)=> {
            const {cards} = category || {};
            return(
                <div key={category?.productCategoryTitle} className={`${styles.capabilities__category} ${selectedCategory === category?.productCategoryTitle ? styles.capabilities__categoryShow : ``}`}>
                    {renderCards(cards)}
                </div>
            )
        })
    }

    const renderCards = cards => {
        if(!cards || cards?.length === 0) return null;

        return cards && cards?.map((item, index)=> {
            return <CapabilityCard key={index} {...item}/>
        });
    }
    
    return (
        <section className={styles.capabilities}>
            <div className='container'>
                <div className={styles.capabilities__inner}>
                    {renderHeadline()}
                    {renderCopy()}
                    <div>
                        <Selector selectedCategory={selectedCategory} setSelectedCategory={setSelectedCategory} data={productCategories}/>
                    </div>
                    <div>
                        {renderCategories()}
                    </div>
                </div>
            </div>
        </section>
    );
}

export default ProductCapabilities;